import React, { useEffect, useState } from 'react';
import * as api from '../../api';
import { RNLLoader } from '../UI';
import { Panel, StatTile } from '../materialTakeoff/MTOShared';

const NAVY = '#0b318b';

// Codes per discipline, and how many of the project's BOQ lines carry a register code.
export default function CGDashboard({ projectId, version, goTo, toast }) {
  const [s, setS] = useState(null);
  useEffect(() => {
    setS(null);
    api.getCodeSummary(projectId).then(setS).catch(e => { toast?.show?.(e.message || 'Could not load the summary', 'error'); setS(false); });
  }, [projectId, version, toast]);

  if (s === null) return <RNLLoader title="Loading codes..." subtitle="Checking the register against the BOQ" />;
  if (!s) return null;
  const pct = s.boq_lines ? Math.round((s.boq_lines_coded / s.boq_lines) * 1000) / 10 : 0;

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 12, marginBottom: 18 }}>
        <StatTile label="Prefix" value={s.prefix || '—'} accent={NAVY} onClick={() => goTo('settings')} />
        <StatTile label="Codes Issued" value={s.total} accent="#334155" onClick={() => goTo('register')} />
        <StatTile label="Free (Reserved)" value={s.reserved} accent="#0369a1" onClick={() => goTo('register', { status: 'reserved' })} />
        <StatTile label="On BOQ Lines" value={s.used} accent="#16a34a" onClick={() => goTo('register', { status: 'used' })} />
        <StatTile label="Void" value={s.void} accent="#b91c1c" onClick={() => goTo('register', { status: 'void' })} />
        <StatTile label="Sub-codes" value={s.sub_codes} accent="#7c3aed" />
        <StatTile label="BOQ Lines Without a Code" value={s.boq_lines_uncoded} accent="#ea580c" onClick={() => goTo('apply')} />
      </div>

      <Panel title={`BOQ lines coded from the register — ${pct}% (${s.boq_lines_coded} of ${s.boq_lines})`}>
        <div style={{ height: 12, borderRadius: 999, background: 'var(--bg-base)', border: '1px solid var(--border-light)', overflow: 'hidden' }}>
          <div style={{ width: `${pct}%`, height: '100%', background: '#16a34a' }} />
        </div>
        <p style={{ fontSize: 12, color: 'var(--text-secondary)', margin: '8px 0 0' }}>
          A line counts as coded when its BOQ code is in this register. Codes typed into an imported workbook are picked up automatically;
          use <b>Apply to BOQ</b> to give the other lines codes in this format.
        </p>
      </Panel>

      <Panel title="By discipline">
        <div style={{ overflowX: 'auto', border: '1px solid black', borderRadius: 10 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr>{['Code', 'Discipline', 'Issued', 'Free', 'On BOQ', 'Void', 'Sub-codes', 'Last No.', 'Next Code'].map(h => (
              <th key={h} style={{ padding: '10px 12px', fontSize: 10, fontWeight: 800, color: '#fff', background: '#0b318bff', border: '1px solid black',
                                    textTransform: 'uppercase', letterSpacing: '0.07em', textAlign: ['Code', 'Discipline', 'Next Code'].includes(h) ? 'left' : 'right' }}>{h}</th>))}</tr></thead>
            <tbody>
              {s.disciplines.map(d => (
                <tr key={d.code} style={{ cursor: 'pointer' }} onClick={() => goTo('register', { discipline: d.code })}>
                  {[
                    [<b style={{ fontFamily: 'monospace', color: NAVY }}>{d.code}</b>, 'left'], [d.name, 'left'], [d.issued], [d.reserved], [d.used], [d.void],
                    [d.sub_codes], [d.last_number || '—'], [<span style={{ fontFamily: 'monospace' }}>{d.next_code || '—'}</span>, 'left'],
                  ].map(([v, align], i) => (
                    <td key={i} style={{ padding: '9px 12px', fontSize: 12.5, borderBottom: '1px solid var(--border-light)', textAlign: align || 'right' }}>{v}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Panel>
    </div>
  );
}
